module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeLocationData && _vm.activeLocationData.contact_point && _vm.activeLocationData.contact_point.contacts) ? _c('div', {
    staticClass: "key-contacts"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row key-contacts__header"
  }, [_c('div', {
    staticClass: "col-s-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.activeLocationData.contact_point.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.activeLocationData.contact_point.contacts), function(contact, i) {
    return _c('div', {
      key: i,
      staticClass: "col-l-3 col-m-6 col-s-12 key-contacts__item"
    }, [(contact.departament) ? _c('div', {
      staticClass: "key-contacts__departament"
    }, [_vm._v(_vm._s(contact.departament))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "key-contacts__details"
    }, [(contact.name) ? _c('div', {
      staticClass: "key-contacts__name"
    }, [_vm._v(_vm._s(contact.name))]) : _vm._e(), _vm._v(" "), (contact.telephone) ? _c('div', {
      staticClass: "key-contacts__telephone"
    }, [_vm._v(_vm._s(contact.telephone))]) : _vm._e(), _vm._v(" "), (contact.email) ? _c('div', {
      staticClass: "key-contacts__email"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + contact.email
      }
    }, [_vm._v(_vm._s(contact.email))])]) : _vm._e()])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a43380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyContacts.vue
// module id = 341
// module chunks = 0